import clsx from "clsx";
import { useState } from "react";
import styles from "./cartList.module.scss";
import { type TCartItem } from "@monta/utils";
import ConfirmDialog from "../confirmDialog";
import { cart } from "#/utils";
import { useBreakLG, useModal } from "@monta/design-system";
import CartItem from "../cartItem";

const CartList = ({ items }) => {
  const controller = useModal();
  const [item, setItem] = useState<TCartItem>();
  const breakLg = useBreakLG();

  const handleRemove = (item?: TCartItem) => {
    if (item) {
      const itemCart = cart.get(
        item.productId ?? item.productPackageId,
        item.targetGroupId,
      );
      itemCart && cart.remove(itemCart);
      setItem(undefined);
    }
  };

  return (
    <div className={clsx(styles["list"], breakLg && "mmb-7")}>
      {items?.map((item, index) => {
        if (!item) return;
        return (
          <div
            className={clsx(index != 0 && styles["outline"])}
            key={`cart-item-${index}`}
          >
            <CartItem
              item={item}
              onRemove={() => {
                controller.open();
                setItem(item);
              }}
              key={item.productPackageId}
            />
          </div>
        );
      })}
      <ConfirmDialog
        controller={controller}
        primaryChoice="no"
        onConfirm={() => item && handleRemove(item)}
        message={"آیا از حذف این مورد اطمینان دارید؟"}
      />
    </div>
  );
};

export default CartList;
